module.exports = "/_next/static/files/84bd07c071f5be2656d304023adb1b6f.svg";